import React from 'react';
import { Typography } from '@material-ui/core';

import useStyles from './useStyles';

const Step = props => {
  const classes = useStyles();
  const { stepNumber, title, description } = props;

  return (
    <div className={classes.container}>
      <Typography variant="h3" color="inherit" className={classes.step}>
        {stepNumber}
      </Typography>
      <div>
        <Typography variant="h3" color="inherit" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="subtitle1">{description}</Typography>
      </div>
    </div>
  );
};

export default Step;



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/Guide/components/Step.js